import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuthContext } from "../pages/AuthContext";
import Button from "./ui/Button";
import { theme } from "../styles/theme";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { currentUser, logout } = useAuthContext();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }
  };

  const isActive = (path) => location.pathname === path;


  const navItems = [
    { path: "/", label: "Início" },
    { path: "/selectquiz", label: "Testes", requiresAuth: true },
    { path: "/results", label: "Resultados", requiresAuth: true },
  ];

  const filteredNavItems = navItems.filter(item => 
    !item.requiresAuth || currentUser
  );

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: isScrolled 
          ? "rgba(255, 255, 255, 0.95)" 
          : "transparent",
        backdropFilter: isScrolled ? "blur(10px)" : "none",
        borderBottom: isScrolled 
          ? `1px solid ${theme.colors.gray[200]}` 
          : "none",
        transition: theme.transitions.normal,
        padding: `${theme.spacing.md} ${theme.spacing.xl}`,
      }}
    >
              <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: isMobile ? `0 ${theme.spacing.md}` : 0,
        }}>
      {/* Logo */}
        <Link
          to="/"
          style={{
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: theme.spacing.sm,
          }}
        >
          <div style={{
            fontSize: theme.typography.fontSize['2xl'],
            fontWeight: theme.typography.fontWeight.bold,
            color: isScrolled ? theme.colors.primary : theme.colors.white,
            transition: theme.transitions.normal,
          }}>
            Draiva
          </div>
        </Link>

                {/* Desktop Navigation */}
        <div 
          className="desktop-nav"
          style={{
            display: isMobile ? "none" : "flex",
            alignItems: "center",
            gap: isMobile ? theme.spacing.md : theme.spacing.xl,
          }}
        >
          {/* Navigation Links */}
          <div style={{
            display: "flex",
            gap: theme.spacing.lg,
          }}>
            {filteredNavItems.map((item) => (
        <Link
                key={item.path}
                to={item.path}
          style={{
            textDecoration: "none",
                  fontWeight: theme.typography.fontWeight.medium,
                  padding: `${theme.spacing.sm} ${theme.spacing.md}`,
                  borderRadius: theme.borderRadius.md,
                  transition: theme.transitions.normal,
                  backgroundColor: "transparent",
                  color: isActive(item.path)
                    ? (isScrolled ? theme.colors.primary : theme.colors.white)
                    : (isScrolled ? theme.colors.gray[700] : theme.colors.white),
                }}
                onMouseEnter={(e) => {
                  if (!isActive(item.path)) {
                    e.target.style.backgroundColor = isScrolled 
                      ? theme.colors.gray[100] 
                      : "rgba(255, 255, 255, 0.1)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive(item.path)) {
                    e.target.style.backgroundColor = "transparent";
                  }
                }}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* Auth Buttons */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: theme.spacing.md,
          }}>
            {currentUser ? (
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.md,
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: theme.spacing.sm,
                  padding: `${theme.spacing.sm} ${theme.spacing.md}`,
                  backgroundColor: isScrolled 
                    ? theme.colors.gray[100] 
                    : "rgba(255, 255, 255, 0.1)",
                  borderRadius: theme.borderRadius.md,
                  color: isScrolled ? theme.colors.gray[700] : theme.colors.white,
                }}>
                  <div style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: theme.colors.success,
                    borderRadius: "50%",
                  }} />
                  <span style={{ fontSize: theme.typography.fontSize.sm }}>
                    {currentUser.email?.split('@')[0] || 'Usuário'}
                  </span>
                </div>
                <Button
                  onClick={handleLogout}
                  size="sm"
                  variant="outline"
                  style={{
                    color: isScrolled ? theme.colors.primary : theme.colors.white,
                    borderColor: isScrolled ? theme.colors.primary : theme.colors.white,
                  }}
                >
                  Sair
                </Button>
              </div>
            ) : (
              <>
                <Link to="/login">
                  <Button
                    size="sm"
                    variant="outline"
                    style={{
                      color: isScrolled ? theme.colors.gray[700] : theme.colors.white,
                      borderColor: isScrolled ? theme.colors.gray[700] : theme.colors.white,
                    }}
                  >
                    Entrar
                  </Button>
                </Link>
                <Link to="/register">
                  <Button
                    size="sm"
                    variant="primary"
                  >
                    Cadastrar
                  </Button>
        </Link>
              </>
            )}
          </div>
      </div>

        {/* Mobile Menu Button */}
      {isMobile && (
      <button
          className="mobile-menu-button"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          background: "none",
          border: "none",
            color: isScrolled ? theme.colors.gray[700] : theme.colors.white,
            fontSize: theme.typography.fontSize.xl,
          cursor: "pointer",
            padding: theme.spacing.sm,
            borderRadius: theme.borderRadius.md,
            transition: theme.transitions.normal,
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = isScrolled 
              ? theme.colors.gray[100] 
              : "rgba(255, 255, 255, 0.1)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
          }}
        aria-label="Abrir menu"
      >
          {isMenuOpen ? "✕" : "☰"}
      </button>
      )}
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          backgroundColor: theme.colors.white,
          borderTop: `1px solid ${theme.colors.gray[200]}`,
          boxShadow: theme.shadows.lg,
          padding: theme.spacing.lg,
          zIndex: 1000,
          animation: "slideDown 0.3s ease-out",
        }}>
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing.md,
          }}>
            {filteredNavItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  textDecoration: "none",
                  fontWeight: theme.typography.fontWeight.medium,
                  padding: theme.spacing.md,
                  borderRadius: theme.borderRadius.md,
                  backgroundColor: "transparent",
                  color: isActive(item.path) 
                    ? theme.colors.primary 
                    : theme.colors.gray[700],
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            
            {currentUser ? (
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: theme.spacing.md,
                paddingTop: theme.spacing.md,
                borderTop: `1px solid ${theme.colors.gray[200]}`,
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: theme.spacing.sm,
                  padding: theme.spacing.md,
                  color: theme.colors.gray[600],
                }}>
                  <div style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: theme.colors.success,
                    borderRadius: "50%",
                  }} />
                  <span>{currentUser.email?.split('@')[0] || 'Usuário'}</span>
                </div>
      <Button
                  onClick={() => {
                    handleLogout();
                    setIsMenuOpen(false);
                  }}
                  variant="outline"
                  fullWidth
                >
                  Sair
      </Button>
              </div>
            ) : (
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: theme.spacing.md,
                paddingTop: theme.spacing.md,
                borderTop: `1px solid ${theme.colors.gray[200]}`,
              }}>
                <Link to="/login" onClick={() => setIsMenuOpen(false)}>
                  <Button variant="outline" fullWidth>
                    Entrar
                  </Button>
                </Link>
                <Link to="/register" onClick={() => setIsMenuOpen(false)}>
                  <Button variant="primary" fullWidth>
                    Cadastrar
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Responsive CSS */}
      <style>
        {`
          .mobile-menu-button {
            display: none !important;
          }
          
          @media (max-width: 768px) {
            .desktop-nav {
              display: none !important;
            }
            .mobile-menu-button {
              display: flex !important;
            }
          }
          
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </nav>
  );
}

export default Navbar;
